<template>
  <div>
    <VisualHero
      image="/assets/img/visual/ucrs-visual-contatto.png"
      background-color="bg-black-light"
    >
      <template slot="title">
        Vendo e compro casa, in sicurezza e semplicità.
      </template>
      <template slot="description">
        <p class="font-bold uppercase text-xl mb-4">
          Siamo l'Agenzia Immobiliare di UniCredit.
        </p>
        <p>
          Sappiamo come "tenere le carte in ordine" e la trasparenza guida ogni
          nostra azione.
        </p>
      </template>
    </VisualHero>

    <TwoColumnsPageContainer side-top="contact">
      <SideFormContainer slot="side" top="nav">
        <ContactForm />
      </SideFormContainer>

      <div slot="body" class="text-black-light mb-20">
        <div
          class="mb-16 gap-y-8 sm:gap-y-16 grid grid-cols-1 sm:grid-cols-2 gap-x-13"
        >
          <IconCard
            v-for="(info, idx) in infos"
            :key="`IconCard_${idx}`"
            :icon="info.icon"
            :title="info.title"
            :content="info.content"
            is-title-h2
          >
            <template v-if="info.linkText" slot="bottom">
              <a
                class="mt-4 flex items-center text-blue font-bold text-base outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:rounded focus-visible:ring-blue"
                href="/assets/pdf/facsimile-reportvalorecasa.pdf"
                target="_blank"
              >
                <SvgIcon
                  :name="info.linkIcon"
                  class="w-9.6 min-w-9.6 h-9.6 mr-4"
                  aria-hidden="true"
                />
                <span>{{ info.linkText }}</span>
              </a>
            </template>
          </IconCard>
        </div>
        <h2 class="font-bold uppercase text-xl mb-8">
          Dai spazio al tuo futuro. Approfitta della promozione Cambio Casa!
        </h2>
        <p class="text-lg">
          Se vendi casa con noi avrai
          <strong>GRATIS l'Attestato di Prestazione Energetica</strong> e saremo
          al tuo fianco fino alla conclusione della compravendita. Cerchi anche
          una nuova casa? Siamo qui per te! Se acquisti un immobile UniCredit RE
          Services avrai una
          <strong>provvigione agevolata del 2,5%<sup>2</sup></strong
          >.
        </p>
        <p class="mt-4 text-xs font-sans">
          La provvigione agevolata per l'acquisto potrà essere applicata,
          qualora l'incarico di mediazione all'acquisto sia sottoscritto entro e
          non oltre entro i 12 mesi successivi alla data del rogito di vendita
          dell'immobile, oggetto di incarico UniCredit RE Services, rientrante
          nella Promozione Cambio Casa.
        </p>
        <!-- <div class="flex mt-20">
          <BrochureAnchor />
        </div> -->
      </div>
      <template slot="footer">
        <section class="pt-20">
          <StripBannerSellEvaluateHome />
        </section>
        <section class="my-16 md:mt-12 md:mb-24">
          <p class="text-xs">
            Note:<br aria-hidden="true" />
            (1) Il Report Valore Casa è stato redatto per conto di UniCredit RE
            Services da Immobiliare.it, società terza ed indipendente. UniCredit
            RE Services non è responsabile di eventuali danni, perdite o
            profitti derivanti dall'uso improprio dei dati riportati nel
            presente documento. Si tratta di una valutazione commerciale che non
            sostituisce stime e valutazioni peritali.<br aria-hidden="true" />
            (2) Promozione valida per i clienti che conferiscono un mandato di
            vendita in esclusiva per 12 mesi a UniCredit RE Services entro il
            31.12.2024. Questa promozione è cumulabile con altre iniziative.
          </p>
        </section>
      </template>
    </TwoColumnsPageContainer>
  </div>
</template>

<script>
// Components
// import BrochureAnchor from '~/components/BrochureAnchor.vue'
import ContactForm from '~/components/ContactForm.vue'
import IconCard from '~/components/IconCard.vue'
import SideFormContainer from '~/components/SideFormContainer.vue'
import TwoColumnsPageContainer from '~/components/TwoColumnsPageContainer.vue'
import StripBannerSellEvaluateHome from '~/components/StripBannerSellEvaluateHome.vue'
import VisualHero from '~/components/VisualHero.vue'

export default {
  components: {
    // BrochureAnchor,
    ContactForm,
    IconCard,
    SideFormContainer,
    TwoColumnsPageContainer,
    StripBannerSellEvaluateHome,
    VisualHero,
  },

  async asyncData({ route, $axios }) {
    let meta
    await $axios
      .get('/_api/api/v1/meta', {
        params: {
          slug: route.name,
        },
      })
      .then((res) => {
        meta = res.data.data
      })
      .catch(() => {
        meta = {
          title:
            'Contatta UniCredit RE Services per le tue Esigenze Immobiliari!',
          description:
            'Contatta subito lo staff di UniCredit RE Services per richiedere informazioni,  ricercare e trovare la soluzione immobiliare adatta a te',
        }
      })
    return { meta }
  },

  data() {
    return {
      infos: [
        {
          title: 'Contatto',
          icon: 'touch',
          content: (
            <div>
              <p class="mb-2">
                Scegliere UniCredit RE Services significa affidarsi a un{' '}
                <strong>team di esperti</strong> nel settore immobiliare che ti
                segue in ogni fase della compravendita, con con una consulenza
                su misura e un supporto digitale avanzato.
              </p>
              <p class="mb-2">
                Compila il <strong>form</strong> e contatta i nostri
                professionisti.
              </p>
              <p>
                Puoi anche chiamare <strong>il numero verde</strong> o puoi
                chiedere di noi in tutte le <strong>Filiali UniCredit</strong>,
                verrai messo in contatto con il consulente immobiliare della tua
                zona.
              </p>
            </div>
          ),
        },
        {
          title: 'Diamo valore alla tua casa',
          icon: 'search-new-circle',
          content: (
            <div>
              <p>Portiamo il tuo immobile sul mercato:</p>
              <ul class="ucrs-list ucrs-list--outside">
                <li>
                  con la <strong>valutazione del Report "Valore Casa"</strong>
                  <sup>1</sup>; un documento <strong>ricco e completo</strong>,
                  con i valori delle compravendite più recenti, i prezzi
                  richiesti per immobili simili e un'attenta analisi della
                  domanda nella zona di riferimento.
                </li>
                <li>
                  con <strong>visite virtuali</strong> e con la massima
                  visibilità sui <strong>principali portali</strong> e su{' '}
                  <strong>YouTube</strong>.
                </li>
              </ul>
            </div>
          ),
          linkText: 'Sfoglia il fac-simile',
          linkIcon: 'read',
        },
        {
          title: 'Tecnologia',
          icon: 'mobile-device',
          content: (
            <div>
              <p>
                <strong>
                  Tecnologia sì ma solo per semplificare la relazione con te
                </strong>
                . Qualche esempio?
              </p>
              <ul class="ucrs-list ucrs-list--outside">
                <li>
                  Il tuo <strong>mandato</strong> verrà{' '}
                  <strong>raccolto con un'app</strong>, senza sprechi di tempo e
                  di carta.
                </li>
                <li>
                  Puoi <strong>visitare</strong> la tua futura casa{' '}
                  <strong>o mostrare la tua abitazione</strong> con il{' '}
                  <strong>virtual tour</strong>, senza sopralluoghi.
                </li>
                <li>
                  <strong>
                    Hai tutti i documenti in regola per vendere, affittare,
                    comprare?
                  </strong>{' '}
                  Puoi acquistarli sul nostro sito, con un semplice click.
                </li>
              </ul>
            </div>
          ),
        },
        {
          title: 'Relazione',
          icon: 'people-circle',
          content: (
            <p>
              <strong>
                Siamo sempre al tuo fianco fino alla conclusione della
                compravendita
              </strong>
              , sia che si tratti di un immobile residenziale, commerciale e di
              pregio, <strong>su tutto il territorio nazionale</strong>.
            </p>
          ),
        },
      ],
    }
  },

  head() {
    return {
      title: this.meta.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.meta.description,
        },
      ],
    }
  },
}
</script>
